


























































import { Component, Vue } from 'vue-property-decorator';
import { userData, db } from '../main';
import FileUploader from '@/components/FileUploader.vue';
const _ = require('lodash');

Vue.component('FileUploader', FileUploader);

@Component
export default class Profile extends Vue {
    public data() {
        return { userData };
    }
    public saveUser() {
        userData.saveUser().then(() => {
            this.$toast.open('Profil sparad');
        });
    }
    public setImgUrl(imgUrl: string) {
        userData.user.avatar = imgUrl;
        this.saveUser();
    }
}
